const startOf = (event) => event.has('pendingStartDate') ? event.get('pendingStartDate') : event.get('startDate');

const dayNumber = (date) => new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();

const compareText = (a, b) => a.localeCompare(b, undefined, {sensitivity: 'base'});

const techGroup = (event) => (event.get('technicianNames') || []).slice().sort(compareText).join(', ');

const compareTechGroups = (a, b) => {
    if(a === b) {
        return 0;
    }
    if(!a) {
        return 1;
    }
    if(!b) {
        return -1;
    }
    return compareText(a, b);
};

// The start day must stay the first key. BaseCalendar gives each event the first free row on its
// start day and keeps it on that row for the rest of the week, which only avoids collisions when
// events arrive in start-day order.
export const compareByDayTechTime = (event1, event2) => {
    const start1 = startOf(event1);
    const start2 = startOf(event2);

    return dayNumber(start1) - dayNumber(start2)
        || (event2.get('eventStatus') === 'holiday') - (event1.get('eventStatus') === 'holiday')
        || compareTechGroups(techGroup(event1), techGroup(event2))
        || start1 - start2;
};
